<template>
  <global-notifications />
  <router-view />

</template>

<style>
  #events {
    margin-top: 10px;
  }
</style>
